import { render, staticRenderFns } from "./ed-section-material-tree.vue?vue&type=template&id=5a208655&scoped=true&"
import script from "./ed-section-material-tree.ts?vue&type=script&lang=ts&"
export * from "./ed-section-material-tree.ts?vue&type=script&lang=ts&"
import style0 from "./ed-section-material-tree.scss?vue&type=style&index=0&id=5a208655&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a208655",
  null
  
)

export default component.exports